// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { Api } from '../../../services/config/Api';
import { WIZARD_TWINGRAPH_QUERIES } from '../WizardConstants';

const getOrganizationId = (state) => state.organization.current?.data?.id;

function* getDataVectorTwingraphQueriesResult(action) {
  const organizationId = yield select(getOrganizationId);
  const { datasetId, scenarioData } = action.payload;

  const scenarioId = scenarioData.id;
  try {
    yield put({
      type: WIZARD_TWINGRAPH_QUERIES.SET_TWINGRAPH_QUERIES_STATUS,
      status: 'LOADING',
    });

    const { data: niveauHierarchique } = yield call(Api.Datasets.twingraphQuery, organizationId, datasetId, {
      query: 'MATCH (n: HierarchieDesEquipements) RETURN n',
    });

    const hierarchieEquipements = niveauHierarchique.map((nh) => nh.n.properties);
    yield put({
      type: WIZARD_TWINGRAPH_QUERIES.PROCESS_DATA_VECTOR_TWINGRAPH_QUERIES,
      payload: { scenarioId, result: hierarchieEquipements },
    });

    yield put({
      type: WIZARD_TWINGRAPH_QUERIES.SET_TWINGRAPH_QUERIES_STATUS,
      status: 'IDLE',
    });
  } catch (e) {
    console.error(e);
  }
}

function* dataVectorTwingraphQueriesResultSaga() {
  yield takeEvery(
    [WIZARD_TWINGRAPH_QUERIES.INITIALIZE_DATA_VECTOR_TWINGRAPH_QUERIES],
    getDataVectorTwingraphQueriesResult
  );
}

export default dataVectorTwingraphQueriesResultSaga;
